import { ErrorResponseRLDtt } from '../../roominglist/responseStatus.types';

export enum PickupStatsAlertFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum PickupStatsAlertStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum PickupStatsAlertEventProduct {
  RESLINK = 'RESLINK',
}

export type PickupStatsAlertPreferences = {
  daily: boolean;
  monthly: boolean;
  thresholds: number[];
  weekly: boolean;
};

export type PickupStatsAlertSubscriber = {
  email: string;
  preferences: PickupStatsAlertPreferences;
  status: PickupStatsAlertStatus;
};

export type PickupStatsAlertSubscriptionGroupInfo = {
  propertyCode: string;
  groupBlockCode: string;
  groupBlockEndDate: string;
  groupBlockStartDate: string;
  groupBlockCutOffDate?: string;
};

export type PickupStatsAlertSubscription = {
  id: string;
  eventId: string;
  eventName: string;
  groupInfo: PickupStatsAlertSubscriptionGroupInfo;
  status: PickupStatsAlertStatus;
  subscribers: PickupStatsAlertSubscriber[];
};

export type GetReslinkPickupStatsAlertSubscriptionsInput = {
  input: {
    eventId: string;
    groupBlockCode?: string;
    timeFrequency?: PickupStatsAlertFrequency;
  };
};

export type GetReslinkPickupStatsAlertSubscriptions = {
  subscriptions: PickupStatsAlertSubscription[];
};

export type GetReslinkPickupStatsAlertSubscriptionsResponse = {
  sales: {
    groupSales: {
      groupManagement: {
        reslinkPickupStatsAlertSubscriptions: GetReslinkPickupStatsAlertSubscriptions | ErrorResponseRLDtt;
      };
    };
  };
};
